import api from '~/api/Endpoints';
import { Searches } from '~/types/searches';
export const getSearchesUuid = async (uuid: string) => {
  return api.get(`/searches/:uuid`, {
    params: { uuid },
  });
};

export interface PutSearchesResponse {
  uuid: string;
  url: string;
  search: Searches.SearchObject;
  name: string;
}
export const putSearches = async (
  item: Searches.SearchObject | Searches.StoredSearchObject
) => {
  return api.put('/searches', {
    body: {
      search: item,
    },
  });
};

export const putSearchesUuid = async (uuid: string) => {
  return api.put(`/searches/:uuid`, {
    params: { uuid },
  });
};

export const getSearchesHistory = async () => {
  return api.get('/searches/history');
};
